import React, { memo } from "react";

import { Container } from "react-bootstrap";
import { Pagination } from "swiper";
import { SwiperSlide, useSwiper } from "swiper/react/swiper-react";
import { ArrowCircleRight } from "iconsax-react";
import { ArrowCircleLeft } from "iconsax-react";

import "swiper/swiper.scss";
import "swiper/modules/navigation/navigation.scss";
import "swiper/modules/pagination/pagination.scss";

import sectionAroundShapeImg from "../../../../image/home/section-around-shape.svg";

import {
  StyledSection,
  WrapperImg,
  SectionInnerWrapper,
  StyledSwiper,
  SwiperButton,
  SwiperButtonsWrapper,
} from "./styledSimsCarousel";
import SingleSimCardComponent from "../../singleSimCard";

export const SlideNextButton = ({ color, className }) => {
  const swiper = useSwiper();
  return (
    <SwiperButton className={className}>
      <ArrowCircleLeft
        onClick={() => swiper.slideNext()}
        variant="Bold"
        color={color ? color : "var(--white-color)"}
        size="48"
      />
    </SwiperButton>
  );
};
export const SlidePrevButton = ({ color, className }) => {
  const swiper = useSwiper();
  return (
    <SwiperButton className={className}>
      <ArrowCircleRight
        onClick={() => swiper.slidePrev()}
        variant="Bold"
        color={color ? color : "var(--white-color)"}
        size="48"
      />
    </SwiperButton>
  );
};

const SimsCarouselSectionComponent = ({ freeSims, error }) => {
  return (
    <StyledSection>
      <WrapperImg
        src={sectionAroundShapeImg}
        className="w-100"
        draggable="false"
        $top
      />
      <SectionInnerWrapper className="pb-3 pb-md-0">
        <Container>
          <h3 className="text-center pt-4 pt-md-0">
            <mark>آزمایش‌های رایگان</mark>
          </h3>
          <p className="text-center">
            به سادگی ثبت‌نام کرده و یادگیری را شروع کنید.
          </p>
          {error ? (
            <p className="text-center py-5 mb-0">
              خطا در دریافت اطلاعات. لطفا دوباره امتحان کنید.
            </p>
          ) : (
            <StyledSwiper
              slidesPerView={1}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 4,
                },
              }}
              spaceBetween={22}
              loop={true}
              pagination={{ clickable: true }}
              modules={[Pagination]}
            >
              <SwiperButtonsWrapper className="mx-auto" $freeSimsCount={freeSims ? freeSims.length : 0}>
                <SlidePrevButton />
                <SlideNextButton />
              </SwiperButtonsWrapper>
              {freeSims ? freeSims.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <SingleSimCardComponent $Carousel data={item} />
                  </SwiperSlide>
                );
              }): null }
            </StyledSwiper>
          )}
        </Container>
      </SectionInnerWrapper>
      <WrapperImg
        src={sectionAroundShapeImg}
        className="w-100"
        draggable="false"
        $bottom
      />
    </StyledSection>
  );
};

export default memo(SimsCarouselSectionComponent);
